module.exports = __webpack_public_path__ + "static/img/nature.ca13f64e.png";